import { apiGetUserConnected } from "@/features/auth/api/auth.api";
import { TMemberProfile } from "@/features/auth/types";
import { store } from "@/store";
import {
  getMemberInfos,
  updateMemberProfile,
  updateMemberCurrentExchange,
  updateIsOnline,
} from "@/store/reducers/member/member.actions";
import { updateOpenDiscussion } from "@/store/reducers/general_param/general_param.actions";
import { TMemberInfos } from "../types";

export const getMeUpdate = () => {
  apiGetUserConnected()
    .then((response: any) => {
      const profile = response.data as TMemberProfile;
      console.log({ profile });
      const infosUser: TMemberInfos = {
        _id: profile.member._id,
        email: profile.member.email,
        role: profile.member.role,
        username: profile.member.username,
        memberId: profile.member.memberId,
        isVerified: store.getState().member.member_infos!?.isVerified,
        isInEmailVerificationProcess:
          store.getState().member.member_infos!?.isInEmailVerificationProcess,
        // Non renvoyé par /profiles/me : préservé depuis le store pour que le
        // bandeau d'impersonation survive à un rechargement de page.
        impersonatedBy: store.getState().member.member_infos?.impersonatedBy,
      };
      console.log({ infosUser });
      store.dispatch(getMemberInfos({ ...infosUser }));
      store.dispatch(updateMemberProfile({ ...profile }));
      store.dispatch(
        updateMemberCurrentExchange(profile?.currentConversation || null)
      );
      store.dispatch(updateOpenDiscussion(!!profile?.currentConversation));
      store.dispatch(updateIsOnline(profile.availability.isAvailable));
    })
    .catch((error) => {
      console.log("😜", error);
    });
};
